import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getNumberValidFilter } from '@anytag/shared-utils';
import { useReportFilterOptions } from '@anytag/shared-hooks';
import {
  Filter,
  SelectorField,
  FILTER_SECTIONS,
  AsyncSearchCampaignField,
  AsyncSearchAdvertiserField
} from '@anytag/shared-molecules';
import { CampaignPostsDiscoveryFilterFormKeys, CampaignPostsDiscoveryFilterFormValues } from './schemaTypes';

interface AdvancedFilterProps {
  onSubmit?: () => void;
}

export const AdvancedFilter = ({ onSubmit }: AdvancedFilterProps) => {
  const { t } = useTranslation();
  const { watch, reset } = useFormContext<CampaignPostsDiscoveryFilterFormValues>();

  const values = watch();
  const numOfValidFilter = getNumberValidFilter<CampaignPostsDiscoveryFilterFormKeys>(values, [
    'keyword',
    'endDate',
    'startDate',
    'influencerIds'
  ]);

  const { allCampaignTypes, allCountryOptions, allSocialMediaPostOptions, allCampaignCategoryOptions } =
    useReportFilterOptions();

  const handleClearAll = () => {
    reset({
      countryIds: [],
      advertiserIds: [],
      socialPostTypes: [],
      campaignTypes: [],
      categoryIds: [],
      campaigns: []
    });
    onSubmit?.();
  };

  return (
    <Filter.MoreFilterPopover
      count={numOfValidFilter}
      onClear={handleClearAll}
      onSubmit={onSubmit}
      defaultOpened={[FILTER_SECTIONS.CampaignPostsDiscovery]}
      items={[
        {
          value: FILTER_SECTIONS.CampaignPostsDiscovery,
          node: (
            <>
              <SelectorField<CampaignPostsDiscoveryFilterFormKeys>
                clearable={false}
                name="countryIds"
                title={t('Selector.Country')}
                options={allCountryOptions}
                placeholder={t<string>('Selector.Country')}
                multiple
              />
              <AsyncSearchAdvertiserField name="advertiserIds" title={t<string>('Selector.Advertiser')} multiple />
              <SelectorField<CampaignPostsDiscoveryFilterFormKeys>
                clearable={false}
                name="socialPostTypes"
                title={t('Selector.Social Media')}
                options={allSocialMediaPostOptions}
                placeholder={t<string>('Selector.Social Media')}
                multiple
              />
              <SelectorField<CampaignPostsDiscoveryFilterFormKeys>
                name="campaignTypes"
                options={allCampaignTypes}
                title={t('Selector.Campaign type')}
                multiple
              />
              <SelectorField<CampaignPostsDiscoveryFilterFormKeys>
                name="categoryIds"
                options={allCampaignCategoryOptions}
                title={t<string>('Campaign Category')}
                placeholder={t<string>('Selector.Campaign Category')}
                multiple
              />
              <AsyncSearchCampaignField
                name="campaigns"
                className="basis-full"
                title={t<string>('Selector.Campaign Name')}
                multiple
              />
            </>
          )
        }
      ]}
    />
  );
};
